import {
  Box,
  Button,
  Heading,
  ModalProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import useTranslate from "hooks/useTranslate";
import SimplePopup from "components/SimplePopup";
import IncentivesContainer from "components/IncentivesContainer";

type IncentivesPopupProps = Omit<ModalProps, "children"> & {};

const IncentivesPopup = ({ onClose, ...rest }: IncentivesPopupProps) => {
  const translate = useTranslate();

  return (
    <SimplePopup size="md" onClose={onClose} {...rest}>
      <VStack w="full" spacing="1" textAlign="center" pt="8">
        <Heading fontSize="2xl" lineHeight="1.3" fontWeight="bold" maxW="18rem">
          {translate("incentives:title")}
        </Heading>

        <Text fontSize="sm" opacity="0.8" maxW="18rem">
          {translate("incentives:description")}
        </Text>
      </VStack>

      <Box
        px={{
          base: "0",
          sm: "2",
        }}
        mt="4"
      >
        <IncentivesContainer />

        <Button w="full" colorScheme="dark" mt="6" onClick={onClose}>
          {translate("common:close")}
        </Button>
      </Box>
    </SimplePopup>
  );
};

export default IncentivesPopup;
